import "./StockValue.scss";

export default function StockValue() {
  return (
    <section className="sales-layout__page stock-value">
      <h1>Lagerwert</h1>
      <p>Hier wird zukünftig der Lagerwert angezeigt.</p>
    </section>
  );
}
